import React from 'react';

import { ApplePay } from '../integration';

export const ApplePayCheckout = (props: ApplePayCheckoutProps) => {
  const { isSubmitting, validateCanPlaceOrder, onCheckout } = props;

  return (
    <ApplePayRequest
      {...props}
      isLoading={isSubmitting}
      validateCanPlaceOrder={validateCanPlaceOrder}
      onCapturePaymentMethodId={onCheckout}
    />
  );
};

const ApplePayRequest = (props: ApplePayRequestProps) => {
  const { validateCanPlaceOrder, onCapturePaymentMethodId } = props;

  return (
    <ApplePay
      {...props}
      validateCanPlaceOrder={validateCanPlaceOrder}
      onCapturePaymentMethodId={onCapturePaymentMethodId}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ApplePayRequestProps = Readonly<{
  isLoading: boolean;
  amountToCapture: number;
  validateCanPlaceOrder: (paymentMethodId?: string) => boolean;
  onCapturePaymentMethodId?: (paymentMethodId: string) => Promise<void>;
}>;

// ─── Types ───────────────────────────────────────────────────────────────────

type ApplePayCheckoutProps = {
  amountToCapture: number;
  isSubmitting: boolean;
  validateCanPlaceOrder: () => boolean;
  onCheckout: (paymentMethodId: string) => Promise<void>;
};
